import { ReactNode, memo } from 'react';

import { twMerge } from 'tailwind-merge';

import './NavbarItem.css';

export interface NavbarItemProps {
  icon: ReactNode;
  isActive?: boolean;
  warning?: boolean;
}

export function NavbarItemBase({ icon, isActive, warning }: NavbarItemProps) {
  return (
    <div
      className={twMerge(
        'navbar-item',
        isActive && 'active',
        warning && 'animate-pulse bg-v2orange-200/50',
      )}
    >
      {icon}
    </div>
  );
}

export const NavbarItem = memo(NavbarItemBase);
